import {Component, OnInit} from '@angular/core';

import {LoadingController, Platform} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import firebase from 'firebase';
import {Router} from '@angular/router';
import {UserService} from '../shared/user-service';
import {GlobalService} from '../shared/services/global.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit {

    constructor(
        private route: Router,
        private platform: Platform,
        private splashScreen: SplashScreen,
        private userService: UserService,
        private statusBar: StatusBar,
        private loadingController: LoadingController,
        private globalService: GlobalService,
    ) {
        this.initializeApp();
    }

    ngOnInit() {
        firebase.auth().onAuthStateChanged(async (auth) => {
            console.log('auth: ', auth);
            if (auth) {
                const loading = await this.loadingController.create({
                    message: 'Validando usuario...',
                    duration: 2000
                });

                await loading.present();

                const doc = await firebase.firestore().collection('configuration').doc('generals').get();
                const generals = doc.data();
                const customers = await this.loadCustomers();

                this.globalService.setGenerals(generals);
                this.globalService.setCustomers(customers);

                await this.userService.setUser(auth);
                await loading.dismiss();
                console.log('1');
                await this.route.navigate(['/list']);
                console.log('2');
            } else {
                await this.route.navigate(['/public']);
            }
        });
    }

    initializeApp() {
        this.platform.ready().then(() => {
            this.statusBar.styleDefault();
            this.splashScreen.hide();
        });
    }

    private async loadCustomers() {
        const docs = await firebase.firestore().collection('customers').get();

        let allCustomers = [];
        docs.forEach(doc => {
            const data = doc.data();
            if (data.customers) {
                allCustomers = allCustomers.concat(data.customers);
            }
        });

        allCustomers = allCustomers.filter((customer, i, self) => i === self.findIndex(c => c.code === customer.code));
        return allCustomers.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
    }
}
